import { ApiPropertyProject } from '@kaiizen/kai-pro-api';
import { useCachedQuery, useQueryCacheMutation } from '@kaiizen/react-persistent-cache';

import { useKaiProApiClient } from '../useKaiProApiClient';

const CONTRACTOR_PROJECTS_QUERY_KEY = 'contractorProjects';

/**
 * Lists the projects the authenticated contractor is assigned to (via the
 * contractor-to-project link). Returns an empty list for non-contractor users.
 */
export const useContractorProjects = () => {
  const kaiProApiClient = useKaiProApiClient();
  const query = useCachedQuery<ApiPropertyProject[]>(
    CONTRACTOR_PROJECTS_QUERY_KEY,
    () => kaiProApiClient.getContractorProjects(),
    { enabled: !!kaiProApiClient.token },
  );
  return { ...query, contractorProjects: query.data };
};

/**
 * Mutation that mints a copyable contractor contractor link for one contractor on a
 * scan, returning `{ url }`. No cache invalidation — it only creates a share link.
 */
export const useCreateContractorScanShareLink = () => {
  const kaiProApiClient = useKaiProApiClient();
  const { mutate, isPending } = useQueryCacheMutation(
    async ({ scanId, orgContractorId }: { scanId: string; orgContractorId: string }) => kaiProApiClient.createContractorScanShareLink(scanId, orgContractorId),
  );
  return { createContractorScanShareLink: mutate, isCreatingShareLink: isPending };
};
